<template lang="pug">
  section
    b-container
      h4 {{ inputForm.title }}
      .breadcrumbs.text-muted.small.py-3
        b-button.btn-dark(:to="{name: 'Art'}")
          font-awesome-icon.mr-2(icon="caret-left")
          span ALL ART
      content-loader(:height="7", v-if="alert.loading")
      b-container(v-else="")
        b-form(@submit.prevent="submitArt")
          b-card.mt-3
            .container
              .row
                .col-md-8
                  b-form-group
                    label TITLE
                    b-form-input.form-control(type='text', required, maxlength="32", v-model='inputForm.title', name='title')
                .col-md-4
                  b-form-group
                    label PRICE
                    b-form-row
                      .col-2
                        span R
                      .col-10
                        b-form-input.form-control(type='number', required, v-model='inputForm.price', step="1", :min="10", name='price', @change="checkRentable")
          b-card.mt-3
              b-container
                p.d-inline(v-if="inputForm.id") IMAGES
                .small.d-inline.ml-3(v-if="inputForm.id") (Skip to leave unchanged)
                br
                br
                .small.text-muted.my-3.d-inline We recommend images that are at least 2240px wide, and are between 1 and 10 Mb in file size. For guidance on which pictures are required, please see our
                a.m-0.text-theme.ml-2(:href="`${client_base_url}/help?audience=artist`", target="_blank") ARTIST FAQs
                .row.pt-3
                  .col-md-4
                    span.mr-2 PRIMARY
                    span.text-muted.small.d-block Full Front-facing Image of Artwork
                    i.fa.fa-check.text-success(v-if="image1")
                    image-uploader.file-upload(
                      id="image-1",
                      :debug="2",
                      :quality="0.9",
                      :maxWidth="2240",
                      :maxHeight="10000",
                      :autoRotate="false",
                      outputFormat="verbose",
                      :preview="true",
                      :className="['fileinput', { 'fileinput--loaded' : hasImage }]",
                      :capture="false",
                      accept="image/*",
                      @input="setImage1")
                  .col-md-4
                      span.mr-2 CLOSE-UP
                      span.text-muted.small.d-block Showing detail and texture
                      i.fa.fa-check.text-success(v-if="image2")
                      image-uploader.file-upload(
                        id="image-2",
                        :debug="2",
                        :quality="0.9",
                        :maxWidth="2240",
                        :maxHeight="10000",
                        :autoRotate="false",
                        outputFormat="verbose",
                        :preview="true",
                        :className="['fileinput', { 'fileinput--loaded' : hasImage }]",
                        :capture="false",
                        accept="image/*",
                        @input="setImage2")
                  .col-md-4
                      span.mr-2 IN A ROOM
                      span.text-muted.small.d-block Hanging and styled in a space
                      i.fa.fa-check.text-success(v-if="image3")
                      image-uploader.file-upload(
                        id="image-3",
                        :debug="2",
                        :quality="0.9",
                        :maxWidth="2240",
                        :maxHeight="10000",
                        :autoRotate="false",
                        outputFormat="verbose",
                        :preview="true",
                        :className="['fileinput', { 'fileinput--loaded' : hasImage }]",
                        :capture="false",
                        accept="image/*",
                        @input="setImage3")
          b-card.mt-3
            .container
              .row
                .col-md-4
                  b-form-group
                    b-form-checkbox(v-model='is_collection', switch) IS THIS PIECE PART OF A COLLECTION?
                .col-md-4(v-if="is_collection")
                  b-form-group
                    label TOTAL CREATED
                    b-form-row
                      b-form-input.form-control(type='number', required, v-model='inputForm.collection_size', step="1", :min="1", name='stock')
                .col-md-4(v-if="is_collection")
                  b-form-group
                    label AVAILABLE
                    b-form-row
                      b-form-input.form-control(type='number', required, v-model='inputForm.stock', step="1", :min="1", name='stock')
          //- b-form-group.mt-3
          //-   b-form-radio-group.text-dark(:options='art_forms', buttons, button-variant="primary", value-field="id", text-field="title", v-model='inputForm.form_id', required)
          b-card.mt-3
            .container
              .row
                .col-md-3
                  b-form-group
                    label FORM
                    b-form-select(:options='art_forms', value-field="id", text-field="title", v-model='inputForm.form_id', required)
                .col-md-3
                  b-form-group
                    label MEDIUM
                    b-form-select(:options='artMedia', value-field="id", text-field="title", v-model='inputForm.medium_id', required)
                .col-md-3
                  b-form-group
                    label STYLE
                    b-form-select(:options='art_styles', value-field="id", text-field="title", v-model='inputForm.style_id', required)
                .col-md-3
                  b-form-group
                    label SUBJECT
                    b-form-select(:options='art_subjects', value-field="id", text-field="title", v-model='inputForm.subject_id', required)
                .col-md-12
                  b-form-group
                    label MATERIALS
                    b-form-textarea(rows='2', max-rows='4' v-model='inputForm.materials', maxlength="127", required='', placeholder='Comment on any significant materials used in this piece (128 characters or less).')
                .col-md-12
                  b-form-group
                    label DESCRIPTION
                    b-form-textarea(rows='3', max-rows='6' v-model='inputForm.description', maxlength="200", required='', placeholder='Tell collectors more about the piece and the materials used to create it (200 characters or less).')
          b-card.mt-3
            .container
              .row
                .col-md-4
                  b-form-group
                    label WIDTH
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.width', name='width', step="1", :min="1", placeholder='0')
                      .col-4
                        span cm
                .col-md-4
                  b-form-group
                    label HEIGHT
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.height', name='height', step="1", :min="1", placeholder='0')
                      .col-4
                        span cm
                .col-md-4
                  b-form-group
                    label DEPTH
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.length', name='length', step="1", :min="1", placeholder='0')
                      .col-4
                        span cm
          .row
            .col-md-6
              b-card.mt-3
                .container
                  .row
                    .col-md-6
                      b-form-group.pb-0.mb-0
                        b-form-checkbox(v-model='inputForm.framed', switch) FRAMED
                    .col-md-6
                      b-form-group.pb-0.mb-0
                        b-form-checkbox(v-model='inputForm.ready_to_hang', switch, @input="checkRentable") READY TO HANG
            .col-md-6
                b-card.mt-3
                  b-form-checkbox(v-model='inputForm.is_rentable', switch, :disabled="!enable_is_rentable") MAKE THIS PIECE AVAILABLE TO RENT
                  div.pt-2
                    p.text-danger(v-if="inputForm.price < 5000") Only pieces over R5000 may be made available to rent
                    p.text-danger(v-else-if="!inputForm.ready_to_hang") Rental pieces must be ready to hang
                    p.text-danger(v-else-if="!inputForm.is_rentable") Are you sure? Rentals are frequently converted into sales after a few months. We highly recommend giving it a try!
          b-card.mt-3
            .container
              .row
                .col-12
                  p DIMENSIONS WHEN PACKED FOR SHIPPING
                .col-md-3
                  b-form-group
                    label WIDTH
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.shipping_width', name='width', :step="1", :min="1", :max="200", placeholder='0')
                      .col-4
                        span cm
                .col-md-3
                  b-form-group
                    label HEIGHT
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.shipping_height', name='height', step="1", :min="1", :max="200", placeholder='0')
                      .col-4
                        span cm
                .col-md-3
                  b-form-group
                    label DEPTH
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.shipping_length', name='height', step="1", :min="1", :max="200", placeholder='0')
                      .col-4
                        span cm
                .col-md-3
                  b-form-group
                    label WEIGHT
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='inputForm.shipping_weight', name='weight', step="1", :min="2", :max="50", placeholder='0')
                      .col-4
                        span kg
              small (Please be as precise as possible- these values are used for shipping calculations)
          .row
            .col-md-6
              b-card.mt-3
                b-form-checkbox(v-model='agree', switch)
                  span(href="") I AGREE TO THE WALL COLLECTIVE
                  a.text-muted.mx-2(:href="`${client_base_url}/legal`", target="_blank") Artist Submission terms
          div.mt-3
            button-load.px-3.mr-3(:disabled="!agree", v-if="inputForm.status == 'available' || inputForm.status == 'declined'|| inputForm.status == 'pending' || !inputForm.id", type="submit", :flag="alert.busy", :label="inputForm.id?'SAVE':'SUBMIT'", classes="btn-light")
            b-button.btn-light(v-if="inputForm.status == 'available' && !alert.busy", @click="deleteArt") REMOVE PIECE
            //- p(v-if="inputForm.status == 'pending'") This piece is currently pending curator review
            //- p(v-else-if="inputForm.id") By updating an active piece, it will first be resubmitted to our curators for approval
            p.mt-2(v-if="alert.busy") Your piece is being processed. Please do not hit back, or refresh this page.

</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import ImageUploader from 'vue-image-upload-resize';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
// import resizebase64 from 'resize-base64';
import router from '@/router';

export default {
  name: 'Events',
  components: {
    ContentLoader,
    ImageUploader,
  },
  mixins: [standardMix],
  data() {
    return {
      art_forms: [],
      art_media: [],
      art_styles: [],
      art_subjects: [],
      enable_is_rentable: false,
      inputForm: {
        title: '',
        form_id: 1,
        style_id: 1,
        subject_id: 1,
        medium_id: 1,
        artist_id: '',
        description: '',
        materials: '',
        price: 0,
        height: 0,
        width: 0,
        length: 0,
        shipping_height: 0,
        shipping_width: 0,
        shipping_length: 0,
        shipping_weight: 0,
        framed: false,
        ready_to_hang: false,
        is_rentable: false,
        collection_size: 1,
        stock: 1,
        files: [],
        fileThumbnail: null,
      },
      is_collection: false,
      previewImageUrl: '',
      hasImage: false,
      agree: false,
      image1: null,
      image2: null,
      image3: null,
    };
  },
  computed: {
    artMedia() {
      return this.art_media.filter(item => item.art_form_id === this.inputForm.form_id);
    },
  },
  methods: {
    async submitArt() {
      if (!this.agree) {
        this.error('Please agree to our terms');
      } else if (!((this.inputForm.images && this.inputForm.files.length === 0) || (this.image1 && this.image2 && this.image3))) {
        this.error('Please upload all required images');
      } else if (this.inputForm.id) {
        // Update existing piece
        if (this.image1 && this.image2 && this.image3) {
          this.inputForm.files = [this.image1, this.image2, this.image3];
        }
        try {
          // Add new piece
          this.clear();
          this.busy();
          await apiService.updateArt(this.profileId, this.inputForm);
          this.success('Piece updated');
        } catch (error) {
          // this.error('Could not add new piece');
          console.log(error);
          this.error(error);
        }
      } else {
        this.inputForm.files = [this.image1, this.image2, this.image3];
        try {
          // Add new piece
          this.busy();
          this.inputForm.artist_id = this.account.user.artist_id;
          await apiService.addArt(this.profileId, this.inputForm);
          this.clear();
          router.push({ name: 'SubmitOk' });
        } catch (error) {
          this.error('Could not add new piece');
        }
      }
    },
    async deleteArt() {
      try {
        this.busy();
        await apiService.deletePiece(this.profileId, this.inputForm.id);
        router.push({ name: 'Art' });
      } catch (error) {
        this.error(error);
      }
    },
    async setImage1(image) {
      if (image.info.orgWidth >= 2240) {
        const file = {
          mime_type: image.info.type,
          data_url: image.dataUrl,
          is_default: true,
        };
        this.image1 = file;
      } else {
        this.error('Image does not meet minimum size requirements');
        this.hasImage = false;
      }
    },
    async setImage2(image) {
      if (image.info.orgWidth >= 2240) {
        const file = {
          mime_type: image.info.type,
          data_url: image.dataUrl,
          is_default: false,
        };
        this.image2 = file;
      } else {
        this.error('Image does not meet minimum size requirements');
        this.hasImage = false;
      }
    },
    async setImage3(image) {
      if (image.info.orgWidth >= 2240) {
        const file = {
          mime_type: image.info.type,
          data_url: image.dataUrl,
          is_default: false,
        };
        this.image3 = file;
      } else {
        this.error('Image does not meet minimum size requirements');
        this.hasImage = false;
      }
    },
    async checkRentable() {
      if (this.inputForm.price < 5000 || this.inputForm.ready_to_hang === false) {
        this.inputForm.is_rentable = false;
        this.enable_is_rentable = false;
      } else if (this.inputForm.price >= 5000 && this.inputForm.ready_to_hang) {
        this.enable_is_rentable = true;
      } else {
        this.enable_is_rentable = false;
      }
    },
  },
  async created() {
    this.loading();
    if (this.$route.params.pieceId) {
      this.inputForm = await apiService.getPiece(this.$route.params.pieceId);
    }
    // Add files field
    this.inputForm.files = [];
    const filters = await apiService.getFilters();
    this.art_forms = filters.art_forms;
    this.art_media = filters.art_media;
    this.art_styles = filters.art_styles;
    this.art_subjects = filters.art_subjects;
    this.clear();
  },
  watch: {
    is_collection(state) {
      if (!state) {
        this.inputForm.stock = 1;
        this.inputForm.collection_size = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .preview-img {
    width: 100px;
  }
  .file-upload {
    input {
      border-bottom: none !important;
    }
  }
  .img-main {
    max-width: 100%;
    max-height: 90vh;
  }
  .img-main-placeholder {
    // border: 1px solid rgb(168, 163, 163);
    max-width: 100%;
    height: calc(50% - 50px);
    .logo {
      width: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Piece.vue